import { render } from "./DualColorButton.vue?vue&type=template&id=55933faa&scoped=true"
import script from "./DualColorButton.vue?vue&type=script&lang=js"
export * from "./DualColorButton.vue?vue&type=script&lang=js"

import "./DualColorButton.vue?vue&type=style&index=0&id=55933faa&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55933faa"]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QImg});
